export const AMIT_THEMABLE_INJECTION_KEY = 'themable-injection-key';
